import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, map, startWith, Subscription } from 'rxjs';
import { ICommitteeSearchData, Option } from '../../shared/models/sr/sr-committee-search-data';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IecBallotService } from '../../shared/services/iec-ballot.service';
import { IIecBallot } from '../../shared/models/iec/IIecBallot';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { IApiResponse } from '../../../../shared/models/api-response';
import { ToastService } from '../../../../shared/services/toast.service';
import { IFileUpload } from '../../../controls/files-upload/files-upload.component';


@Component({
    selector: 'app-iec-create',
    templateUrl: './iec-create.component.html',
    styleUrl: './iec-create.component.scss',
    standalone: false
})
export class IecCreateComponent {
  subscriptions: Subscription = new Subscription();

  draftFileUploadProgress: number[] = [0];
  commentTemplateFileUploadProgress: number[] = [0];

  hasInvalidDraftFile: boolean = false;
  hasInvalidCommentTemplate: boolean = false;

  loading: boolean = false;

  ballotForm = new FormGroup({
    committeeCtrl: new FormControl('', Validators.required),
    referenceCtrl: new FormControl('', Validators.required),
    linkCtrl: new FormControl(''),
    titleCtrl: new FormControl('', Validators.required),
    startDateCtrl: new FormControl(null, Validators.required),
    endDateCtrl: new FormControl(null, Validators.required),
  });

  draftFile: File | undefined;
  commentTemplate: File | undefined;

  voteOptions = ['In Favour Of','Against','Abstain'];

  constructor(
    private _iecBallotService: IecBallotService,
    private _toastService: ToastService,
    private _router: Router
  ) {}

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  cancel() {
    this.ballotForm.reset();
  }

  private _filter(value: string, options: Option[]): Option[] {
    const filterValue = value.toLowerCase();
    return options.filter((option) =>
      option.label.toLowerCase().includes(filterValue)
    );
  }

  handleSelectedDatesChange(selectedDatesForm: FormGroup): void {
    this.ballotForm.get('startDateCtrl')?.setValue(selectedDatesForm.get('startDateCtrl')?.value??null);
    this.ballotForm.get('endDateCtrl')?.setValue(selectedDatesForm.get('endDateCtrl')?.value??null);
  }

  addDraftFiles(file: IFileUpload) {

    if(file.hasError) {
      this.hasInvalidDraftFile = true;
      this.draftFile = undefined;
      return;
    }
    else
    {
      this.hasInvalidDraftFile = false;
    }
    if (!file.files[0]) return;

    this.draftFile = file.files[0];
  }

  addCommentTemplateFiles(file: IFileUpload) {

    if(file.hasError)
    {
      this.hasInvalidCommentTemplate = true;
      this.commentTemplate = undefined;
      return;
    }
    else
    {
      this.hasInvalidCommentTemplate = false;
    }
    if (!file.files[0]) return;
    this.commentTemplate = file.files[0];
  }


  redirectToCreateBallotPage() {
    this._router.navigate(['/ballots/create']);
  }

  redirectToBallotPage() {
    this._router.navigate(['/ballots']);
  }

  createBallot() {
    let iecBallot: IIecBallot = {
      designation: this.ballotForm.get('referenceCtrl')?.value ?? '',
      title: this.ballotForm.get('titleCtrl')?.value ?? '',
      iecLink: this.ballotForm.get('linkCtrl')?.value ?? '',
      committeeCode: this.ballotForm.get('committeeCtrl')?.value ?? '',
      startDate: this.ballotForm.get('startDateCtrl')?.value ?? new Date(),
      endDate: this.ballotForm.get('endDateCtrl')?.value ?? new Date(),
    };

    this.loading = true;

    this.subscriptions.add(this._iecBallotService.createBallot(iecBallot).subscribe({
      next: (response: IApiResponse<string>) => {
        let ballotId = response.content;

        if (this.draftFile) this.uploadDraftFile(ballotId, this.draftFile);
        else this.postBallotCreation();

      },
      error: (error) => {
        this._toastService.showError("Ballot not created due to an unexpected error. Please try again or contact IT Support if issue persists.", "IEC Ballot");
      }
    }));
  }



  uploadDraftFile(ballotId: string, file: File) {
    this.subscriptions.add(this._iecBallotService.uploadDraftFile(ballotId, file).subscribe({
      next: (event: IApiResponse<any>) => {
        if (this.commentTemplate) this.uploadCommentTemplateFiles(ballotId, this.commentTemplate);
        else this.postBallotCreation();
      },
      error: (error) => {
        console.log(`An error occurred: ${error}`);
      },
    }));
  }

  uploadCommentTemplateFiles(ballotId: string, file: File) {
    this.subscriptions.add(this._iecBallotService
      .uploadCommentTemplateFile(ballotId, file)
      .subscribe({
        next: (event: IApiResponse<any>) => {
          this.postBallotCreation();
        },
        error: (error) => {
          console.log(`An error occurred: ${error}`);
        },
      }));
  }

  postBallotCreation() {
    this.redirectToBallotPage();
    this._toastService.showSuccess("Ballot was successfully created.", "IEC Ballot");
    this.loading = false;
  }
}
